import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChatEntity } from '../../domain/entities/ChatEntity'
import type { SupportMessageListedAdminDto } from '@/backend/market'

export class ChatModel extends ChatEntity {
  constructor(dataDto: SupportMessageListedAdminDto) {
    super()
    mapEntityProperties<ChatEntity>(this, dataDto)
  }
}
